import { QText, useToastProvider } from '@qualio/ui-components';
import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../../containers/confirmation-modal';
import { ApiKey, ModalComponentProps } from '../../types';
import { createErrorToast } from '../../utils/toast.utils';
import { rotateDevApiToken } from '../../api/medtech-api';

type RotateApiTokenModalProps = ModalComponentProps & {
  token: ApiKey;
  companyId: number;
  onRotated: (newToken: string) => void;
};

export const RotateApiTokenModal: React.FC<RotateApiTokenModalProps> = ({
  closeModal,
  token,
  companyId,
  onRotated,
}) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isRotating, setIsRotating] = useState(false);

  const handleRotate = async (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsRotating(true);
    try {
      const apiKey = await rotateDevApiToken(companyId, token.id);
      onRotated(apiKey.token);
      closeModal();
    } catch {
      setIsRotating(false);
      showToast(createErrorToast(t('messages.error.rotateToken'), 'dev-api-rotate-token-error-toast'));
    }
  };

  return (
    <ConfirmationModal
      closeModal={closeModal}
      title={t('developerApi.confirmRotateTitle')}
      confirmDataCy="confirm-rotate-token"
      buttonProps={{
        isLoading: isRotating,
        onClick: handleRotate,
        label: t('developerApi.table.rotate'),
      }}
    >
      <QText>{t('developerApi.confirmRotateMessage', { tokenName: token.name })}</QText>
    </ConfirmationModal>
  );
};
